// Standalone. Adds the print-ready file link to the product's Shopify
// line-item properties (hidden property `_print_ready_file`) on add-to-cart.
// No dependency on expivi-bundle.js / expiviCartAfterStore.

var CLIENT_SUBDOMAIN = 'racketup';
var PRINT_READY_DPI = 300;

function createVariant(savedBundle) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'POST',
            url: '/apps/configurator',
            data: JSON.stringify({
                configuration: savedBundle.configured_products,
                productId: shopifyProductId
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(function (createResult) {
            createResult.configuredProduct = savedBundle.configured_products[0];
            resolve(createResult);
        }).fail(reject);
    });
}

function requestPrintReadyFile(configuredProduct, mediaId, dpi) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: '/apps/configurator',
            type: 'POST',
            data: JSON.stringify({
                svg_convert: true,
                configuration: {
                    catalogue_id: configuredProduct.catalogue_id,
                    attributes: configuredProduct.configuration.attributes
                },
                media_id: mediaId,
                format: 'pdf',
                dpi: dpi,
                hide_printmarks: true,
                hide_placeholders: true,
                cmyk: false
            }),
            contentType: 'application/json'
        }).done(function (response) {
            if (!response.status) {
                console.error('svg_convert rejected. media_id:', mediaId,
                    'catalogue_id:', configuredProduct.catalogue_id,
                    'response:', response);
                return reject(new Error('print-ready conversion failed'));
            }
            resolve('https://' + CLIENT_SUBDOMAIN + '.expivi.net/print-ready-service?hash=' + response.hash);
        }).fail(function () {
            reject(new Error('print-ready request failed'));
        });
    });
}

function getPrintReadyFiles(configuredProduct, dpi) {
    var seen = {};
    var uniqueMediaIds = [];

    configuredProduct.attributes.forEach(function (attr) {
        if (
            attr.attribute_value &&
            Number.isInteger(attr.attribute_value.media_id) &&
            attr.attribute_value.svg_element
        ) {
            var mediaId = attr.attribute_value.media_id;
            if (!seen[mediaId]) {
                seen[mediaId] = true;
                uniqueMediaIds.push(mediaId);
            }
        }
    });

    if (uniqueMediaIds.length === 0) {
        return Promise.resolve([]);
    }

    return Promise.all(
        uniqueMediaIds.map(function (mediaId) {
            return requestPrintReadyFile(configuredProduct, mediaId, dpi);
        })
    );
}

function addToCart(createResult, printReadyFilePaths) {
    return new Promise(function (resolve, reject) {
        var searchParams = new URLSearchParams(window.location.search);
        var quantity = searchParams.get('quantity') || 1;

        var properties = Object.assign({}, createResult.options);
        if (printReadyFilePaths && printReadyFilePaths.length > 0) {
            printReadyFilePaths.forEach(function (filePath, index) {
                properties['_print_ready_file_' + (index + 1)] = filePath;
            });
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({
                id: createResult.variant_id,
                quantity: quantity,
                properties: properties,
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(resolve).fail(reject);
    });
}

window.xpv_hooks_add_to_cart = function (context, event) {
    $button = $(context);
    shopifyProductId = $button.data('productId');

    if ($button[0].hasAttribute('disabled')) {
        return false;
    }
    event.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.addClass('loading');

    return Promise.resolve()
        .then(function () {
            return expivi.saveConfiguration(512, 512);
        })
        .then(function (savedBundle) {
            return createVariant(savedBundle);
        })
        .then(function (createResult) {
            return getPrintReadyFiles(createResult.configuredProduct, PRINT_READY_DPI)
                .then(function (filePaths) {
                    return addToCart(createResult, filePaths);
                });
        })
        .then(function () {
            if ($button.data('url') !== 'NONE') {
                window.location.href = $button.data('url');
            }
            return false;
        })
        .catch(function (error) {
            $button.removeAttr('disabled');
            $button.removeClass('loading');
            if (error && error.invalid) {
                console.error(error.message);
                return;
            }
            throw error;
        });
}